import React from 'react';
import Header from '../../components/ui/Header';
import Seo from '../../components/Seo';
import Icon from '../../components/AppIcon';

const UpdatesPage = () => {
  const updates = [
    {
      date: 'December 2025',
      tag: 'New',
      title: 'Cyber Essentials Certification',
      description: 'Neevii is now Cyber Essentials certified, demonstrating our commitment to cybersecurity best practices and protecting your financial data.',
      icon: 'Shield'
    },
    {
      date: 'December 2025',
      tag: 'New',
      title: 'AI-Assisted Tax Filing',
      description: 'Streamlined Self Assessment and Corporation Tax preparation. Our AI pre-fills returns, flags potential deductions, and guides you through HMRC submission.',
      icon: 'FileText',
      features: [
        'Personal Self Assessment (SA100)',
        'Corporation Tax returns (CT600)',
        'Automatic expense matching',
        'HMRC-ready submissions'
      ]
    },
    {
      date: 'December 2025',
      tag: 'New',
      title: 'AI Accountant Chat',
      description: 'Your always-available financial advisor. Powered by Google Gemini, with full context of your accounts—ask questions, get instant answers, and receive guidance tailored to your business.',
      icon: 'MessageSquare',
      features: [
        'Full context of your transactions',
        'Natural language queries',
        'Tax & compliance guidance',
        'Powered by Gemini Pro'
      ]
    },
    {
      date: 'December 2025',
      tag: 'New',
      title: 'Tax & Business Calendar',
      description: 'Stay on top of every deadline with a unified calendar that tracks all your important dates. Never miss a filing deadline or payment due date again.',
      icon: 'Calendar',
      features: [
        'Tax deadline tracking (SA, CT, VAT)',
        'Payroll date reminders',
        'Invoice due date alerts',
        'Custom notes & reminders'
      ]
    },
    {
      date: 'December 2025',
      tag: 'New',
      title: 'Agent Services for Accountants',
      description: 'File taxes on behalf of your clients with full HMRC agent registration and client management. Streamline your practice with a dedicated workspace for managing multiple clients.',
      icon: 'Users',
      features: [
        'HMRC agent registration',
        'Client management dashboard',
        'File on behalf of clients',
        'Multi-client tax submissions'
      ]
    },
    {
      date: 'December 2025',
      tag: 'New',
      title: 'Charity Mode',
      description: 'Purpose-built accounting for charities with dedicated pages for tracking donations and managing Gift Aid claims. Maximise your charity\'s tax relief with automated Gift Aid processing.',
      icon: 'Heart',
      features: [
        'Donation tracking',
        'Gift Aid claims management',
        'Charity compliance tools',
        'Automated Gift Aid processing'
      ]
    },
    {
      date: 'Coming Soon',
      tag: 'Preview',
      title: 'Bank Feed Integration',
      description: 'Connect your bank accounts for automatic transaction imports. Support for all major UK banks via Open Banking.',
      icon: 'Link'
    },
    {
      date: 'Coming Soon',
      tag: 'Preview',
      title: 'Smart Reporting Dashboard',
      description: 'Advanced analytics beyond basic reports. Includes profit margin trends, expense forecasting, tax liability projections, client profitability analysis, comparative period insights, and export to PDF/Excel for accountants.',
      icon: 'BarChart3',
      features: [
        'Profit margin trends over time',
        'Expense forecasting & budgets',
        'Tax liability projections',
        'Client profitability breakdown',
        'Period-over-period comparisons',
        'Export to PDF/Excel'
      ]
    }
  ];

  return (
    <>
      <Seo
        title="Updates & New Features | Neevii"
        description="See the latest updates and upcoming features for Neevii's AI-powered accounting platform."
      />
      <div className="min-h-screen">
        <Header />
        <main className="pt-24 pb-16 px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-4xl font-bold text-foreground mb-4">Updates & New Features</h1>
            <p className="text-xl text-muted-foreground mb-12">
              See what's new and what's coming next for Neevii.
            </p>

            <div className="space-y-6">
              {updates.map((update, i) => (
                <div key={i} className="p-6 bg-card rounded-xl border border-border hover:border-primary/30 transition-colors">
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 bg-accent/20 rounded-lg flex items-center justify-center flex-shrink-0">
                      <Icon name={update.icon} size={24} className="text-accent" />
                    </div>
                    <div className="flex-1">
                      <div className="flex items-center gap-3 mb-2">
                        <span className={`px-2 py-0.5 text-xs font-medium rounded ${
                          update.tag === 'New' 
                            ? 'bg-green-500/20 text-green-400' 
                            : 'bg-blue-500/20 text-blue-400'
                        }`}>
                          {update.tag}
                        </span>
                        <span className="text-sm text-muted-foreground">{update.date}</span>
                      </div>
                      <h2 className="text-xl font-semibold text-foreground mb-2">{update.title}</h2>
                      <p className="text-muted-foreground">{update.description}</p>
                      {update.features && (
                        <ul className="mt-3 grid grid-cols-2 gap-2">
                          {update.features.map((feat, j) => (
                            <li key={j} className="flex items-center gap-2 text-sm text-muted-foreground">
                              <Icon name="Check" size={14} className="text-accent flex-shrink-0" />
                              {feat}
                            </li>
                          ))}
                        </ul>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* CTA */}
            <div className="mt-12 p-8 bg-card rounded-2xl border border-border text-center">
              <h2 className="text-2xl font-bold text-foreground mb-4">Want early access?</h2>
              <p className="text-muted-foreground mb-6">
                Join our waitlist to be the first to try new features.
              </p>
              <a 
                href="/subscription"
                className="inline-flex items-center px-6 py-3 bg-accent text-accent-foreground rounded-lg font-medium hover:bg-accent/90 transition-colors"
              >
                Join Waitlist
                <Icon name="ArrowRight" size={20} className="ml-2" />
              </a>
            </div>
          </div>
        </main>
      </div>
    </>
  );
};

export default UpdatesPage;

